'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFirstMessageText = undefined;

var _reselect = require('reselect');

var _getAvailabilityAwayMessage = require('../../availability/selectors/getAvailabilityAwayMessage');

var _getInitialMessageText = require('../../selectors/widgetDataSelectors/getInitialMessageText');

var getFirstMessageText = exports.getFirstMessageText = (0, _reselect.createSelector)([_getAvailabilityAwayMessage.getAvailabilityAwayMessage, _getInitialMessageText.getInitialMessageText], function (awayMessage, initialMessageText) {
  return awayMessage || initialMessageText;
});


//////////////////
// WEBPACK FOOTER
// ./js/thread-histories/selectors/getFirstMessageText.js
// module id = 460
// module chunks = 2 3